<template>
  <div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :max-height="tableHeight"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Operation Time" min-width="223">
          <template v-slot="{ row }">
            <div v-if="row.operationTime">{{ formatUtc(row.operationTime) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Type" min-width="223">
          <template v-slot="{ row }">
            <div>{{ feachType(row.type) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Before" min-width="278">
          <template v-slot="{ row }">
            <div v-if="row.operationBefore < 0">-</div>
            <div v-else>{{ row.operationBefore }}</div>
          </template>
        </el-table-column>
        <el-table-column label="After" min-width="222">
          <template v-slot="{ row }">
            <div v-if="row.operationAfter < 0">-</div>
            <div v-else>{{ row.operationAfter }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Operator" min-width="223">
          <template v-slot="{ row }">
            <div v-if="row.operation < 0">-</div>
            <div v-else>{{ row.operation }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";
import { getModifyLog } from "@/api/memberDetail";
export default {
  components: {
    Empty
  },
  props: {
    handleCheckHistoryStatus: {
      type: Boolean
    },
    handleCheckUserInfoStatus: {
      type: Boolean
    }
  },
  data() {
    return {
      list: [],
      loading: false,
      queryData: {
        userId: 0
      },
      tableHeight: window.innerHeight
    };
  },
  watch: {
    handleCheckHistoryStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 150;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 150;
        });
      }
    },
    handleCheckUserInfoStatus(val) {
      if (val) {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 + 115;
        });
      } else {
        this.$nextTick(() => {
          let self = this;
          self.tableHeight =
            window.innerHeight - self.$refs.table.$el.offsetTop - 94 - 115;
        });
      }
    }
  },
  methods: {
    async getList() {
      this.queryData.userId = this.$route.query.userId;
      this.loading = true;
      try {
        const res = await getModifyLog(this.queryData);
        const data = res.data || {};
        this.list = data || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    feachType(val) {
      if (val == 0) {
        return "User Limit";
      }
      if (val == 1 || val == 4) {
        return "Label";
      }
      if (val == 2) {
        return "Status";
      }
      if (val == 3) {
        return "Alert";
      }
      if (val == 5) {
        return "Level";
      }
      if (val == 6) {
        return "oddsLevel";
      }
      if (val == 7) {
        return "selfRisk";
      }
      if (val == 8) {
        return "check";
      }
      if (val == 9) {
        return "odds Drop Templater";
      }
      if (val == 10) {
        return "suspend Betting Factor";
      }
      if (val == 11) {
        return "Delay Order";
      }
      if (val == 12) {
        return "Delay Settle";
      }
      if (val == 13) {
        return "margin Odds Level";
      }
      if (val == 1001) {
        return "Early Payout - Soccer";
      }
      if (val == 3001) {
        return "Early Payout - Basketball";
      }
    },
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    }
  },
  mounted() {
    this.getList();
    let self = this;
    self.tableHeight = window.innerHeight - self.$refs.table.$el.offsetTop - 94;
    window.onresize = function() {
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
    };
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped></style>
